import { memo } from 'react'
import { useAgentRuntime } from '@/context/AgentProvider'
import { AgentToolCallStatus } from '@multiplayer-app/ai-agent-types'
import type { ToolCallHeaderProps } from './types'
import { getToolStatusMessage } from './utils'

export const ToolCallHeader = memo(({ call }: ToolCallHeaderProps) => {
  const runtime = useAgentRuntime()
  const isCompleted = call.status === AgentToolCallStatus.Succeeded || call.status === AgentToolCallStatus.Failed

  // Only shown in debug mode while the call is in flight.
  if (!runtime.config.debug || isCompleted) return null

  const definition = runtime.tools.get(call.name)
  const toolLabel = definition?.label ?? call.name

  return (
    <div className='mp-agent-tool-header'>
      <div className='mp-agent-tool-simple-message'>{getToolStatusMessage(call, toolLabel)}</div>
    </div>
  )
})

ToolCallHeader.displayName = 'ToolCallHeader'
